"use strict";

/*

js function list:

*/



$(function () {
  // 
  $(".faq-box dt").on("click", function () {
    $(this).next().slideToggle();
    $(this).parent().toggleClass("active");
  }); // 

  $(".drawerNav").on("click", function () {
    $(this).toggleClass("active");
    $(this).next().toggleClass("active");
    $('body').toggleClass("drawerOn");
  });
  $(".drawerCont a").on("click", function () {
    $(".drawerNav").toggleClass("active");
    $(".drawerCont").toggleClass("active");
    $('body').toggleClass("drawerOn");
  });
    $(".dropdown dt").on("click", function () {
    $(this).next().slideToggle();
    $(this).parent().toggleClass("active");
  }); // 
});




var wh = $(window).height();
var spFlg = 'false'; // media query

if (matchMedia) {
  var mq = window.matchMedia("(max-width: 767px)");
  mq.addListener(WidthChange);
  WidthChange(mq);
}

function WidthChange(mq) {
  if (mq.matches) {
    // SPのみ
    spFlg = 'true';
  } else {
    // PCのみ
    spFlg = 'false';
  }
} // スクロールで要素が表示された時にclassを付与する


function inview(target, timing) {
  if (target.length > 0) {
    var winScroll = $(window).scrollTop();
    var winHeight = $(window).height();
    var scrollPos = winScroll + winHeight * timing;

    if (target.offset().top < scrollPos) {
      target.addClass('is-show');
    } else {
      target.removeClass('is-show');
    }
  }
}

$(window).on('load scroll', function () {
  // 汎用アニメーションCSS
  $('.anm').each(function () {
    inview($(this), 0.9);
  }); // アニメーションCSS　カスタム
  // FOOTER の領域に入ったら、.pagetopの色を白に
  $('.anm2').each(function (){
    inview($(this),0.01);
  });
  if($('#footer').hasClass('is-show')) {
    $('.pagetop').addClass('inversion');
  } else {
    $('.pagetop').removeClass('inversion');
  }
  if($('#PageContainer').hasClass('is-show')) {
    $('.pagetop').addClass('is-show');
  } else {
    $('.pagetop').removeClass('is-show');
  }
}); // ブラウザバック時にホワイトアウトするのを回避

history.replaceState(null, document.getElementsByTagName('title')[0].innerHTML, null);
window.addEventListener('popstate', function (e) {
  window.location.reload();
});

if (navigator.userAgent.indexOf('Android') > 0) {
  $("body").addClass("Android");
}

; // クリックイベント周り

$('.acd').children('dt').on('click', function () {
  $(this).toggleClass('active');
  $(this).next().slideToggle(100);
});
$('#navBtn').on('click', function () {
  $(this).toggleClass('active');
  $(this).next().toggleClass('active');

  function navToggle() {
    $('#gnav').toggleClass('on');
  }

  setTimeout(navToggle, 100);
});
$('.pagetop').on('click', function () {
  $("html,body").animate({
    scrollTop: 0
  }, '300');
}); // page scroll

$('a[href*=\\#]:not([href=\\#])').on('click', function () {
  if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
    var target = $(this.hash);

    if (this.hash === '#law' || this.hash === '#pp' || this.hash === '#pearl-slide01' || this.hash === '#pearl-slide02' || this.hash === '#pearl-slide03' || this.hash === '#pearl-slide04' || this.hash === '#pearl-slide05' || this.hash === '#pearl-slide06' || this.hash === '#pearl-slide07' || this.hash === '#pearl-slide08') {
      return;
    }

    target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');

    if (target.length) {
      if (spFlg == 'true') {
        $('html,body').animate({
          scrollTop: target.offset().top - 57
        }, 600);
      } else {
        $('html,body').animate({
          scrollTop: target.offset().top - 91
        }, 600);
      }

      return false;
    }
  }
}); // ロード完了時

$(window).on('load', function () {
  $('#loading').fadeOut(100);
  $('body').addClass('fadeout');
}); // slick

$(function () {
  $('.fv-slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    speed: 1500,
    fade: true,
    arrows: false,
    dots: true
  });
  $('.slider-product').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    speed: 800,
    arrows: true,
    dots: false,
    infinite: false,
    responsive: [{
      
      breakpoint: 992,
      settings: {
        slidesToShow: 3
      }
    }, {
      breakpoint: 768,
      settings: {
        slidesToShow: 2
      }
    }]
  });
    $('.pearl-slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    speed: 1500,
    fade: true,
    arrows: false,
    dots: true
  });

  });



